import React, { useRef } from 'react';
import DownloadPdfButton from '../../../common/download-pdf-button/DownloadPdfButton';
import './amazon.css';

const Amazon = () => {
    const contentRef = useRef(null);

    return (
        <div className="pdf-page-wrapper">
            <DownloadPdfButton contentRef={contentRef} filename="amazon-dsp-guide" />
            <div className="amazon-container" ref={contentRef}>
                <img src="../../../assets/images/amazonDSP/amazon_logo6.png" alt="Amazon DSP logo" className='amazon-img' />

            <p className="amazon-title-headline">Activation Guide: Private Auction and Preferred Deals (Video Only)</p>

            <p className="">
                This document is a guide for self-service campaign managers to setup up Non-Guaranteed Private
                Marketplace (PMP) deals targeting OLV and STV. The content of this guide outlines recommended
                Amazon DSP best practices for deal activation and how to avoid targeting settings that will
                decrease delivery rate.
            </p>
            <p >
                For PG deals, refer to the Activation Guide: Programmatic Guaranteed (Video Only)
            </p>
            <p className="amazon-sub-title-headline">
                1. Getting Started
            </p>
            <p className="amazon-sub-title-headline">
                2. Always On Deals
            </p>
            <p className="amazon-sub-title-headline">
                3. Custom Deals
                <p className="amazon-sub-title-headline">
                    3.1 Before setting up deals
                </p>
                <p className="amazon-sub-title-headline">
                    3.2 API Enabled Deals Setup
                </p>
                <p className="amazon-sub-title-headline">
                    3.3 Non-API Deals (Manual Mapping) Setup
                </p>

            </p>
            <p className="amazon-sub-title-headline">
                4. Campaign Setup
                <p className="amazon-sub-title-headline">
                    4.1 STV Deal Line Item Setup
                </p>
                <p className="amazon-sub-title-headline">
                    4.2 STV Creative Considerations
                </p>
                <p className="amazon-sub-title-headline">
                    4.3 Recommended OLV Line Item Deal setup
                </p>

            </p>

            <p className="amazon-sub-title-headline">
                5. Troubleshooting
            </p>



            <p>&nbsp; </p>
            <p className="amazon-title-headline">1. Getting Started</p>
            <p>
                When setting up an order targeting deals, it is likely you will find a deal that fits your campaign
                needs in the Discovery Tab of the DSP Inventory Hub. These Always on Deals are curated by our
                team and ready to be targeted in your line item settings, helping to save time during campaign
                implementation.
            </p>


            <p>&nbsp; </p>
            <p className="amazon-title-headline">2. Always On Deals</p>
            <p>
                To discover Always on Deals, follow the next steps:
            </p>

            <p className="amazon-list">
                <p>
                    <b>2.1</b> Under the Campaign manager, in the left-hand menu, click on the ‘Amazon DSP’ icon:
                </p>
                <img src="../../../assets/images/amazonDSP/1.png" alt="Amazon DSP discovery tab screenshot" className='amazon-img' />

                <p>&nbsp; </p>

                <p>
                    <b>2.2</b> Under this icon, select "Inventory" . In the "Discovery" tab you will be able to browse the wide
                    selection of always on deals. Use the filters to next to the search bar to assist with the browsing
                </p>
                <img src="../../../assets/images/amazonDSP/2.png" alt="Discovery filters screenshot" className='amazon-img' />
                <p>&nbsp; </p>
                <p>
                    You can find out more about Inventory Hub here. Once you have identified the deals that you will
                    like to include for your order proceed to step 4 “Campaign Setup” of this guide.</p>
            </p>






            <p> &nbsp;</p>
            <p className="amazon-title-headline">3. Custom Deals</p>

            <p>
                If your order requires a custom deal (i.e. negotiated a deal with an SSP or publisher), those can be
                created easily through <b> Inventory Hub.</b>

            </p>

            <p className="amazon-sub-title-headline">3.1 Before setting up deals</p>

            <p className="amazon-list">
                <b>3.1.1. </b>
                Determine the SSP and publisher for your campaign.
                <ul>
                    <li >
                        If Amazon Publisher Direct (APD; fka Amazon Publisher Services - APS), please make sure you
                        have your entity ID and entity name readily available as you will need to share these with
                        your Amazon representative, to push the deal to your entity.
                    </li></ul>
                <p className="amazon-list">
                    <ul>
                        <li >
                            You can find your entity ID within your DSP URL:
                            <img src="../../../assets/images/amazonDSP/3.png" alt="Entity ID location screenshot" className='amazon-img' />
                        </li>
                        <l>&nbsp;</l>
                        <li >

                            You can find your entity name at the top right-hand corner within campaign manager
                            <img src="../../../assets/images/amazonDSP/4.png" alt="Entity name location screenshot" className='amazon-img' />
                        </li>
                    </ul>
                </p>


                <li className="amazon-outline-bullet">
                    When using 3P SSPs or Amazon 1P Inventory use the Deal Creation ID. You can find <b>Deal Creation ID</b> in the SSP and seat IDs table in Amazon DSP Settings.
                </li>
                <p className="amazon-list">
                    <ul>
                        <li >
                            Navigate to Account access and settings from the bottom left gear icon.
                        </li>
                        <li >
                            Click on products from the left panel followed by “Go to Amazon DSP settings”.
                            <img src="../../../assets/images/amazonDSP/5.png" alt="Amazon DSP settings screenshot" className='amazon-img' />
                        </li>

                        <li >
                            You will find the table in the “advance” section.
                            <img src="../../../assets/images/amazonDSP/101.png" alt="Seat ID table screenshot" className='amazon-img' />
                        </li>
                    </ul>
                </p>
                <p className='amazon-tips'><b>Tip:</b> If you already have an AdX seat ID created, please ensure that you have access to the <b>Google Authorized Buyers</b> platform as you will need this in future steps. If a new AdX seat was created, you will receive an email invitation from Google automatically. If you do not have access or never received an email, please include this in your outreach to your Amazon Ads account representative.   </p>



            </p>


            <p> &nbsp;</p>
            <p className="amazon-list">
                <b>3.1.2. </b>
                Once the above has been sourced, reach out to the publisher/SSP with the following information. This is an opportunity to discuss which deals and targeting might work best for your order.


                <p className="amazon-list">
                    If you don’t have a publisher contact or are unsure what SSP/publisher you would like to work with and
                    need recommendations, please reach out to your Amazon Ads Account representative with the below
                    information.

                    <ul>
                        <li >Advertiser:</li>
                        <li >Flight Dates:</li>
                        <li >Budget: (optional) Ensure the budget provided is Media Budget not Total Cost.</li>
                        <li>Creative Length:</li>
                        <li >Format:</li>
                        <li >SSP:</li>
                        <li >Publisher(s):</li>
                        <li >KPI:</li>
                        <li >Contextual Alignment (if applicable):</li>
                        <li >Additional Targeting* (if applicable):</li>
                    </ul>

                    Additionally, this is a great time to request creative specs if you haven’t already and provide creative
                    tags if you have those at hand. The publisher should help you validate your creatives are up to their
                    specs. Wrong creative specs are a frequent blocker for STV/OLV orders.


                </p>
                <p className='amazon-tips'><b>Tip on Additional Targeting:</b> It is good practice to tailor deals to your required targeting parameters.
                    This includes geo targeting, line item frequency capping, audience targeting, device type (desktop,
                    mobile, CTV), environment (web vs. app), video ad format (in-stream vs. outstream), rating/genre/app
                    blocking, brand safety filters, etc. Knowing what is targeted in the deals will also simplify delivery
                    troubleshooting.</p>

            </p>
            <p> &nbsp;</p>
            <p className="amazon-list">
                <b>3.1.3. </b>
                After negotiations between you and the publisher are finalized, the deal is ready to be setup in the DSP.
            </p>
            
            <p className="amazon-sub-title-headline">3.2 API Enabled Deals Setup</p>

            <p className="amazon-list">
                Amazon DSPs API integration with SSPs allows for deals to be automatically sync after targeting
                details and corresponding seat ID has been shared with the publisher. Amazon DSP has an API
                integration with the following supply sources: For none,
                <ul>
                    <li>Amazon Publisher Direct</li>
                    <li>Xandr (formerly known as Appnexus)</li>
                    <li>Magnite DV+ (formerly known as Rubicon)</li>
                    <li>Google Adx</li>

                </ul>
            </p>
            <p className='amazon-tips'><b>Tip: </b> AdX the deals will surface in your entity within 24 hours after being accepted in the <b>Google
                Authorized Buyers</b> platform (if you don’t have access or never received an email invitation to Google
                Authorized Buyers please reach out to your Amazon representative).


                <p><b>Tip:</b> Having trouble finding your deal? Please confirm the correct seat ID was used and that the deal is
                    active by the publisher. If issues still persist, reach out to your Amazon representative.</p>

                <p><b>Warning:</b> Take into consideration that Magnite DV+ has an integration with ADSP but that is not the
                    case with Magnite CTV (formerly Telaria) which houses most of STV inventory.
                </p>
            </p>


            <p className="amazon-sub-title-headline">3.3 Non-API Deals (Manual Mapping) Setup</p>

            <p className="amazon-list">
                <b>3.3.1. </b>Under the Campaign manager, in the left-hand menu, click on the ‘Amazon DSP’ icon:

                <img src="../../../assets/images/amazonDSP/1.png" alt="Amazon DSP navigation screenshot" className='amazon-img' />
            </p>

            <p> &nbsp;</p>
            <p className="amazon-list">
                <b>3.3.2. </b>Within the “Amazon DSP” icon, select "Inventory".
            </p>


            <p> &nbsp;</p>
            <p className="amazon-list">
                <b>3.3.3. </b>Click ‘New Deal’ under the ‘Discovery’ tab
                <img src="../../../assets/images/amazonDSP/8.png" alt="New Deal button screenshot" className='amazon-img' />
            </p>


            <p> &nbsp;</p>
            <p className="amazon-list">
                <b>3.3.4. </b>You will be prompted to select, either ‘<b>Private marketplace</b>’ or ‘<b>Amazon marketplace</b>’. For
                Amazon market place, follow these steps [LINK]. For ‘<b>Private marketplace</b>’ continue below:
            </p>


            <p> &nbsp;</p>
            <p className="amazon-list">
                <b>3.3.5. </b>Next, you will need to fill all details based on what’s been agreed with the publisher:

                <ul className="amazon-list">
                    <li className="amazon-outline-bullet">Name: (For your reference, won’t impact delivery)</li>
                    <li className="amazon-outline-bullet">Source: The agreed SSP with publisher</li>
                    <li className="amazon-outline-bullet">Media Type: Video</li>
                </ul>

                <img src="../../../assets/images/amazonDSP/9.png" alt="Deal details screenshot" className='amazon-img' />

                <ul className="amazon-list">
                    <li className="amazon-outline-bullet">Type: select either Private Auction or Preferred Deal (check with publisher if unsure)</li>
                    <li className="amazon-outline-bullet">Deal ID: (provided by the publisher)</li>
                    <li className="amazon-outline-bullet">Publisher: (Optional)</li>
                </ul>


                <img src="../../../assets/images/amazonDSP/10.png" alt="Deal permissions screenshot" className='amazon-img' />

                <ul className="amazon-list">
                    <li className="amazon-outline-bullet">Permissions:</li>
                    <li className="amazon-outline-bullet">Recommended Advertisers:</li>
                </ul>

                <p> &nbsp;</p>
                <p className='amazon-tips'><b>Tips:</b>This new feature allow for deals to be only discoverable for selected advertisers.</p>

                <p> &nbsp;</p>
                <img src="../../../assets/images/amazonDSP/11.png" alt="Tips screenshot" className='amazon-img' />

                <ul className="amazon-list">
                    <li className="amazon-outline-bullet">Currency</li>
                    <li className="amazon-outline-bullet">CPM (Provided by Publisher)</li>
                    <li className="amazon-outline-bullet">Dates (Optional)</li>
                </ul>
                <p> &nbsp;</p>
                <img src="../../../assets/images/amazonDSP/12.png" alt="Currency and CPM screenshot" className='amazon-img' />
            </p>
            <p> &nbsp;</p>
            <p className='amazon-tips'><b>Warning:</b> Please ensure all information is accurate as some fields <b>(Deal ID & Source)</b> will not be
                editable after saving. This is all manual entry so there is a risk for mistakes causing poor or no delivery.

            </p>

            <p> &nbsp;</p>
            <p className="amazon-title-headline">4. Campaign Setup</p>
            <p>At the order level, add a Order name</p>
            <ul className="amazon-list">
                <li className="amazon-outline-bullet">PO number and comments are optional</li>
                <li className="amazon-outline-bullet">Do not select Amazon Market Place Deals - This is for Amazon Audience
                    Guaranteed campaigns only.</li>
                <li className="amazon-outline-bullet">Frequency caps at the order level should be equal or broader than the
                    frequency cap at a line item level. We recommend leaving uncapped at order
                    level for best results, and adjust as the campaign progresses based on
                    performance and delivery.</li>
                <li className="amazon-outline-bullet">
                    Recommended Goal KPIs will differ depending on environment:</li>
            </ul>
            <p className="amazon-list">
                <ul>
                    <li >For STV we recommend an Awareness Goal and Reach KPI . We
                        recommend a Bid Strategy set to “while spending full budget, maximize
                        performance” and automated optimization switched on or off based on
                        your requirements. Selecting other settings can cause delivery issues.
                    </li>
                    <li >For OLV we recommend selecting either Awareness or Consideration
                        Goals, we recommend Reach KPI for Awareness and Video Completion
                        Rate or Cost per Video Complete for Consideration. Bid Strategy should be set to “while spending full budget, maximize performance”. We
                        recommend to opt-in to Automated optimizations.
                    </li>

                </ul>
            </p>

            <p className="amazon-sub-title-headline">4.1 STV Deal Line Item Setup</p>
            <p className="amazon-list">
                <b>4.1.1  </b>
                Create a new line item and select “video” as the type and assign a name to it.

                    <img src="../../../assets/images/amazonDSP/16.png" alt="STV line item setup screenshot" className='amazon-img' />
                <p> &nbsp;</p>
                <b>4.1.2 </b>
                Select a relevant category for your advertiser as this will be used for competitive separation.
                We recommend 1 sub-category - max 3.

                <p> &nbsp;</p>

                Scroll down to “Inventory” and select the change button next to deals. Select the previously
                created relevant deals to your order. Remove all other inventory.
            </p>
            <p> &nbsp;</p>
            <p className='amazon-tips'><b>Tip:</b>When setting up lines, we recommend to take into account your requirements. For example, if you
                have specific budgets per publisher, best practice will be to have one PMP deal assigned per line to have
                a granular control. Avoid having multiple deals with big difference in CPMs assigned to the same line,
                this could result in a poor bidding strategy

                <img src="../../../assets/images/amazonDSP/17.png" alt="Best practices screenshot" className='amazon-img' />


                <p> &nbsp;</p>
                <b>4.1.4 </b>
                Continue to set the rest of targeting levers, you can find our recommended best practice
                below:
                <table className="stv-table">
                    <thead>
                        <tr>
                            <th>Targeting</th>
                            <th>Availability</th>
                            <th>Best Practice STV</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stvTargetingTable.map((row, index) => (
                            <tr key={index}>
                                <td className='tdBold'>{row.targeting}</td>
                                <td>{row.availability}</td>
                                <td>{row.bestPractice}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>


                <p> &nbsp;</p>
                <b>Sample setup for reference:</b>
                    <img src="../../../assets/images/amazonDSP/18.png" alt="Sample setup screenshot" className='amazon-img' />



                <p> &nbsp;</p>
                <b>4.1.5 </b>
                Setup line item budgets to “Automate budget allocation” unless you have specific budgets for
                the line to spend.
                <img src="../../../assets/images/amazonDSP/19.png" alt="Line item budget screenshot" className='amazon-img' />

                <p> &nbsp;</p>
                <b>4.1.6 </b>
                Setup frequency to 3 to 5 per day for line item settings and adjust based on delivery and
                performance.
                <img src="../../../assets/images/amazonDSP/20.png" alt="Frequency settings screenshot" className='amazon-img' />

                <p> &nbsp;</p>
                <b>4.1.7 </b>
                Set base bid to the deals floor rate.

                <p> &nbsp;</p>
                <b>4.1.8 </b>
                Max Average CPM should be set to blank for Preferred Deals, fix rate deals, to avoid friction
                with deal settings.
                    <img src="../../../assets/images/amazonDSP/21.png" alt="Max average CPM screenshot" className='amazon-img' />

            </p>

            <p> &nbsp;</p>
            <p className="amazon-sub-title-headline">4.2 STV Creative Considerations</p>

            <p className="amazon-list">
                Make sure to check the Amazon STV Specs and cross check those align to your creative. There are some key call-outs for STV to take into consideration, see below:
                <ul className="amazon-list">
                    <li className="amazon-outline-bullet">
                        Verify the creative length is no lower or greater than the targeted length. Most common
                        lengths are 15s and 30s, if the creative is longer please reach out to your Amazon
                        representative to discuss further options.
                    </li>
                    <li className="amazon-outline-bullet">
                        STV does not support VPAID. 3rd party Verification via Double Verify, IAS, MOAT and Adloox
                        are supported for monitoring pixels only across Prime Video ads. Only pixel based tags and
                        VAST are supported.
                    </li>
                    <li className="amazon-outline-bullet">
                        Prime Video requires 15mbps at a minimum for video bit-rate.
                    </li>
                    <li className="amazon-outline-bullet">
                        Verify specific creative requirements with publishers when targeting 3P, it’s a good idea to
                        share the creatives with them to check creative based on their specs.
                    </li>
                    <li className="amazon-outline-bullet">
                        When uploading assets to ADSP, we recommend to do this 48hrs prior to start date to allow
                        for additional encoding required.
                    </li>
                    <li className="amazon-outline-bullet">
                        Do not include any CTAs like “Learn More” enticing users to click on the ad. STV is CTV
                        inventory on it’s majority, which does not allow for users to click.
                    </li>
                </ul>

                We also recommend to get familiar with the Amazon Ads Streaming TV ad policies.
            </p>


            <p> &nbsp;</p>
            <p className="amazon-sub-title-headline">4.3 Recommended OLV Line Item Deal setup</p>
            <p className="amazon-list">
                <b>4.3.1  </b>
                Create a new line item and select “video” as the type and assign a name to it.

                <img src="../../../assets/images/amazonDSP/16.png" className='amazon-img' />

                <p> className='amazon-tips'><b>Tip:</b> We setting up lines, we recommend to take into account your requirements. For example, if you
                    have specific budgets per publisher, best practice will be to have one PMP deal assigned per line to have
                    a granular control. Avoid having deals with a large disparity in CPMs assigned to the same line as this
                    would result in a poor bidding strategy</p>


                <p> &nbsp;</p>
                <b>4.3.2 </b>
                Continue to edit the rest of targeting levers, you can find our recommendation below:

                <table className="stv-table">
                    <thead>
                        <tr>
                            <th>Targeting</th>
                            <th>Availability</th>
                            <th>Best Practice STV</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stvTargetingTable.map((row, index) => (
                            <tr key={index}>
                                <td className='tdBold'>{row.targeting}</td>
                                <td>{row.availability}</td>
                                <td>{row.bestPractice}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>


                <p> &nbsp;</p>
                <b>4.3.3 </b>
                Setup <b>line item budgets</b> to “Automate budget allocation” unless you have specific budgets for the line to spend.
                <img src="../../../assets/images/amazonDSP/21.png" className='amazon-img' />


                <p> &nbsp;</p>
                <b>4.3.4 </b>
                Setup <b>frequency</b> caps to 3 to 5 per day for line item settings and adjust based on delivery and
                performance.
                <img src="../../../assets/images/amazonDSP/24.png" alt="Frequency cap screenshot" className='amazon-img' />


                <p> &nbsp;</p>
                <b>4.3.5 </b>
                Set base bid to the deals floor rate.
                <img src="../../../assets/images/amazonDSP/25.png" alt="Base bid screenshot" className='amazon-img' />


                <p> &nbsp;</p>
                <b>4.3.6 </b>
                Max Average CPM should be set to blank for Preferred Deals, fix rate deals, to avoid friction
                with deal settings.
            </p>

            <p> &nbsp;</p>
            <p className="amazon-title-headline">5. Troubleshooting</p>
            Reach out to your Amazon Representative for further support.
            </div>
        </div>
    );
}

export default Amazon;


const stvTargetingTable = [
    {
        targeting: "Device Type",
        availability: "Yes",
        bestPractice: "For maximum reach, target all devices. CTV accounts for a high percentage of the available inventory for STV."
    },
    {
        targeting: "Mobile Environment",
        availability: "Yes",
        bestPractice: "Not recommended as it might restrict delivery."
    },
    {
        targeting: "Audience Targeting",
        availability: "Yes",
        bestPractice: "Apply cautiously with high reach (RON) lines to drive reach and penetration. Prefer publisher targeting when possible."
    },
    {
        targeting: "Location Targeting",
        availability: "Yes",
        bestPractice: "Recommended, best when applied at state level or 20+ DMAs."
    },
    {
        targeting: "Ratings and Genres Exclusion",
        availability: "Yes",
        bestPractice: "Should be applied to deals if possible."
    },
    {
        targeting: "Domain Targeting",
        availability: "Yes",
        bestPractice: "STV inventory is mainly app-based; domains don’t apply. Avoid to reduce friction with deal settings."
    },
    {
        targeting: "Streaming TV App Blocking",
        availability: "Yes",
        bestPractice: "Use cautiously for Always-On deals as it may restrict delivery. Coordinate with SSP/Publisher for custom deals."
    },
    {
        targeting: "Video Initiation Type",
        availability: "Yes",
        bestPractice: "Not recommended as it might restrict delivery."
    },
    {
        targeting: "Video Ad Format",
        availability: "No",
        bestPractice: "Not recommended as it might restrict delivery."
    },
    {
        targeting: "Player Size",
        availability: "No",
        bestPractice: "Not recommended as it might restrict delivery."
    },
    {
        targeting: "Video Completion Rate",
        availability: "Yes",
        bestPractice: "Not recommended as it might restrict delivery. Completion rate is naturally high for STV."
    },
    {
        targeting: "Dayparting",
        availability: "Yes",
        bestPractice: "Consider consumer viewership behavior when applying dayparting."
    },
    {
        targeting: "Contextual",
        availability: "No",
        bestPractice: "Not recommended as it might restrict delivery."
    },
    {
        targeting: "Amazon 1P Viewability",
        availability: "Yes ",
        bestPractice: "Not recommended as it might restrict delivery. STV is highly viewabile by design."
    },
    {
        targeting: "Language",
        availability: "Yes (Amazon Streaming TV only)",
        bestPractice: "Not recommended as it might restrict delivery. For custom deals work with the SSP/Publisher to target preferred language. This link here will help identify what language targeting is available."
    },
    {
        targeting: "3rd Party Pre-Bid",
        availability: "No",
        bestPractice: "This link here will help identify what pre-bids are safe to use for STV."
    }
];



const olvTargetingTable = [
    {
        targeting: "Device Type",
        availability: "Yes",
        bestPractice: "Exclude STV from device targeting to focus on Desktop and Mobile devices."
    },
    {
        targeting: "Mobile Environment",
        availability: "Yes",
        bestPractice: "Not recommended."
    },
    {
        targeting: "Audience Targeting",
        availability: "Yes",
        bestPractice: "For awareness orders, focus on broad targeting that helps drive reach."
    },
    {
        targeting: "Location Targeting",
        availability: "Yes",
        bestPractice: "Recommended, best when applied at state level or 20+ DMAs."
    },
    {
        targeting: "Ratings and Genres Exclusion",
        availability: "Yes",
        bestPractice: "Rating and genre exclusion should be applied to deals if possible."
    },
    {
        targeting: "Domain Targeting",
        availability: "Yes",
        bestPractice: "Only applicable for 3P targeted deals. If possible, curate deals to exclude undesirable domains."
    },
    {
        targeting: "Streaming TV App Blocking",
        availability: "No",
        bestPractice: "Not applicable for OLV."
    },
    {
        targeting: "Video Initiation Type",
        availability: "Yes",
        bestPractice: "Keep to 'Any' unless advertiser has specific requirements."
    },
    {
        targeting: "Video Ad Format",
        availability: "Yes",
        bestPractice: "Keep both unless advertiser has specific requirements. Allowing all formats maximizes reach. For custom deals, work with SSP/Publisher."
    },
    {
        targeting: "Player Size",
        availability: "Yes",
        bestPractice: "Keep to 'Any' unless advertiser has specific requirements."
    },
    {
        targeting: "Video Completion Rate",
        availability: "Yes",
        bestPractice: "Recommended only for VCR campaigns. Higher VCR filters exclude more inventory."
    },
    {
        targeting: "Dayparting",
        availability: "Yes",
        bestPractice: "Keep to 'Any' unless advertiser has specific requirements."
    },
    {
        targeting: "Contextual",
        availability: "Yes",
        bestPractice: "Use cautiously for Always-On deals as it may restrict delivery. Coordinate with SSP/Publisher for custom deals."
    },
    {
        targeting: "Amazon 1P Viewability",
        availability: "Yes",
        bestPractice: "Recommended to set 50% viewability if not pre-negotiated in deal targeting."
    },
    {
        targeting: "Language",
        availability: "Yes",
        bestPractice: "Not recommended as it may restrict delivery. For custom deals, work with SSP/Publisher for preferred language targeting."
    },
    {
        targeting: "3rd Party Pre-Bid",
        availability: "Yes",
        bestPractice: "Use only safe pre-bids suitable for OLV to avoid restricting delivery."
    }
];